module.exports = __webpack_public_path__ + "img/BackgroundImage_03.4a7d9e9b.png";